import React from 'react';
import { Trans } from '@lingui/macro';
import { Link, Group } from '@landr/maestro';
import { RoutePaths } from 'types/enums';
import { useToLocalizedPath } from 'hooks/useToLocalizedPath/useToLocalizedPath';
import { Filter } from 'types/generated/graphql';

export const SubFilterList = ({
    path,
    subFilters,
}: {
    path: RoutePaths;
    subFilters: Filter[];
}) => {
    const toLocalizedPath = useToLocalizedPath();

    return (
        <Group direction="vertical" gutter="xxs">
            {subFilters?.map(
                (subFilter) =>
                    !!subFilter && (
                        <Group.Item>
                            <Link
                                href={toLocalizedPath(
                                    `/${path}/${subFilter.code}`,
                                )}
                                contrast="low"
                                hasUnderline="hover"
                            >
                                <Trans id={subFilter.code} />
                            </Link>
                        </Group.Item>
                    ),
            )}
        </Group>
    );
};
